import { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import api, { fmtINR } from "@/lib/api";
import { useBranding } from "@/context/BrandingContext";
import PoweredByFooter from "@/components/PoweredByFooter";

export default function PayslipPrint() {
  const { id } = useParams();
  const [p, setP] = useState(null);
  const brand = useBranding();
  useEffect(() => { api.get(`/payroll/${id}`).then((r) => setP(r.data)); }, [id]);
  useEffect(() => {
    if (p) {
      window.onafterprint = () => window.close();
      setTimeout(() => window.print(), 400);
    }
  }, [p]);

  useEffect(() => {
    document.documentElement.classList.add("print-mode-a4");
    return () => document.documentElement.classList.remove("print-mode-a4");
  }, []);
  if (!p) return <div className="p-8">Loading...</div>;

  return (
    <div className="min-h-screen bg-slate-100 flex justify-center py-6">
      <div className="print-a4 shadow-lg" style={{ fontSize: "12px" }}>
        <div className="flex items-center gap-3 border-b-2 border-blue-800 pb-2">
          <img src={brand.logo_url} alt={brand.name} className="h-14 object-contain" />
          <div className="flex-1 text-center">
            <div className="font-display font-semibold">{brand.name}</div>
            <div className="text-[10px] text-slate-600">{[brand.tagline, brand.address].filter(Boolean).join(" · ")}</div>
          </div>
          <div className="ml-auto text-right">
            <div className="font-bold text-lg">PAYSLIP</div>
            <div className="text-[11px]">For the month of <b>{p.month}</b></div>
          </div>
        </div>
        <div className="grid grid-cols-3 gap-2 mt-3 text-[11px] border-b pb-3">
          <div><span className="label-tiny">Employee Code</span><div className="font-mono">{p.emp_code}</div></div>
          <div><span className="label-tiny">Name</span><div className="font-medium">{p.name}</div></div>
          <div><span className="label-tiny">Designation</span><div>{p.designation}</div></div>
          <div><span className="label-tiny">Department</span><div>{p.department}</div></div>
          <div><span className="label-tiny">Days Present</span><div className="font-mono">{p.days_present} / {p.working_days}</div></div>
          <div><span className="label-tiny">Total Hours</span><div className="font-mono">{p.total_hours}</div></div>
        </div>

        <div className="grid grid-cols-2 gap-6 mt-4">
          <div>
            <div className="label-tiny mb-2">EARNINGS</div>
            <table className="w-full text-sm">
              <tbody>
                <tr className="border-b"><td className="py-1">Basic (Gross)</td><td className="text-right font-mono">{fmtINR(p.gross)}</td></tr>
                <tr className="border-b"><td className="py-1">Earned (Pro-rated)</td><td className="text-right font-mono">{fmtINR(p.earned)}</td></tr>
              </tbody>
            </table>
          </div>
          <div>
            <div className="label-tiny mb-2">DEDUCTIONS</div>
            <table className="w-full text-sm">
              <tbody>
                <tr className="border-b"><td className="py-1">Provident Fund (12%)</td><td className="text-right font-mono">{fmtINR(p.pf)}</td></tr>
                <tr className="border-b"><td className="py-1">Professional Tax</td><td className="text-right font-mono">{fmtINR(p.prof_tax)}</td></tr>
                <tr className="border-b font-semibold"><td className="py-1">Total Deductions</td><td className="text-right font-mono">{fmtINR(p.deductions)}</td></tr>
              </tbody>
            </table>
          </div>
        </div>

        <div className="mt-6 bg-blue-50 border border-blue-200 p-3 flex justify-between items-center">
          <div>
            <div className="label-tiny">NET PAY</div>
            <div className="text-2xl font-mono font-bold text-blue-800">{fmtINR(p.net)}</div>
          </div>
          <div className="text-[11px] text-slate-600">Generated on {new Date(p.generated_at).toLocaleDateString("en-IN")}</div>
        </div>

        <div className="mt-8 text-[10px] text-slate-500 border-t pt-2 text-center">
          This is a system-generated payslip and does not require signature. · {brand.name}{brand.address ? ` · ${brand.address}` : ""}
        </div>
        <PoweredByFooter />
      </div>
      <div className="fixed top-2 right-2 no-print">
        <button onClick={() => window.print()} className="bg-blue-700 text-white px-3 py-1 text-sm rounded-sm">Print</button>
      </div>
    </div>
  );
}
